import { Box, Stack } from "@mui/material";
import { DataGridLoading, FormContent, FormDrawer, FormHeader, StateMessage } from "Common/Components";
import { ReferenceListItem, ViewReference } from "./Components";
import { useReferences } from "./Hooks";
import { IReferences } from "./Interfaces";

export const MobileReferenceDrawer = (props: IReferences) => {
  const { referenceDrawer, setReferenceDrawer, resetReference, pageResetKey, handleDocumentView } = props;
  const {
    referencesError,
    viewError,
    references,
    selectedReference,
    setSelectedReference,
    setActiveParagraphReference,
    pageNumber,
    setParagraphs,
    modifiedPdfUrl,
    isReferencesListFetching,
    isReferenceLoading,
    warningMessage,
  } = useReferences(props);

  return (
    <FormDrawer open={referenceDrawer ?? false}>
      <FormHeader
        title="References"
        handleClose={() => {
          if (typeof setReferenceDrawer === "function") {
            setReferenceDrawer(false);
            resetReference();
          }
        }}
      />

      <FormContent>
        <DataGridLoading isLoading={isReferencesListFetching}>
          <>
            {(referencesError || viewError) && !referenceDrawer && (
              <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <StateMessage message={"Error occurred"} secondaryMessage={"An error occurred while loading references."} />
              </Box>
            )}

            {!referencesError && references?.length === 0 && !referenceDrawer && (
              <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <StateMessage message={"No Data to Display"} secondaryMessage="This list has no data." />
              </Box>
            )}

            {!referencesError && references && references.length !== 0 && !selectedReference && (
              <Box sx={{ overflowY: "auto", maxHeight: `calc(100vh - 150px)` }}>
                <Stack spacing={2}>
                  {references.map((reference) => (
                    <ReferenceListItem
                      key={reference.fileId}
                      onClick={() => handleDocumentView(reference.fileUrl, 1)}
                      title={reference.title}
                      description={reference.description}
                      fileLink={reference.fileUrl}
                      fileName={reference.fileName}
                      fileType={reference.fileType}
                    />
                  ))}
                </Stack>
              </Box>
            )}

            {selectedReference && (
              <ViewReference
                isLoading={isReferenceLoading}
                onClick={() => {
                  setSelectedReference(undefined);
                  resetReference();
                  setActiveParagraphReference(undefined);
                  setParagraphs(undefined);
                }}
                reference={selectedReference}
                initialPage={pageNumber ?? 1}
                modifiedUrl={modifiedPdfUrl}
                pageResetKey={pageResetKey}
                warningMessage={warningMessage}
              />
            )}
          </>
        </DataGridLoading>
      </FormContent>
    </FormDrawer>
  );
};
